import { TabPanel } from '@mui/lab'
import { styled } from '@mui/material'

const StyledTabPanel = styled(TabPanel)({
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 8,
  paddingBottom: 0,
})

export default StyledTabPanel
